import {
	CircularProgress,
	Grid,
	IconButton,
	Paper,
	Stack,
	Typography,
} from '@mui/material';

import React, { useState, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { ReactComponent as RightArrow } from 'common/assets/images/right-chevron-circle.svg';
import { rrcpDashboardRoutes } from 'common/constants/rrcp-dashboard-routes';
import { urlWithTenant } from 'common/utils/utilFunctions';

import { ITestMonitoringTestStatusTable } from '../api/type-def';

import { DividingLine } from '../../../common/assets/images';

import styles from './TestMonitoringHeader.module.scss';

interface ITMHeaderProps {
	isLoading: boolean;
	dateCountData: ITestMonitoringTestStatusTable[];
}

const dateInCorrectFormatWithFullYear: any = (time: string) => {
	const date = new Date(time);
	const formattedDate = date.toLocaleString('en-US', {
		month: '2-digit',
		day: '2-digit',
		year: '2-digit',
	});
	const correctTime = `${formattedDate}`;
	return correctTime;
};

const TestMonitoringHeader = ({ isLoading, dateCountData }: ITMHeaderProps) => {
	const [countData, setcountData] = useState({
		newCount: 0,
		pastDueCount: 0,
		dueSoonCount: 0,
	});

	useEffect(() => {
		const currentDate: any = new Date();
		const newCount = dateCountData.filter(
			(item: any) =>
				dateInCorrectFormatWithFullYear(item.committedStartDate) >=
				dateInCorrectFormatWithFullYear(currentDate),
		).length;

		const pastDueCount = dateCountData.filter(
			(item: any) =>
				dateInCorrectFormatWithFullYear(item.committedEndDate) <
				dateInCorrectFormatWithFullYear(currentDate),
		).length;

		const dueSoonCount = dateCountData.filter((item: any) => {
			const endDate = new Date(item.committedEndDate);
			const timeDiff = endDate.getTime() - currentDate.getTime();
			const daysDiff = timeDiff / (1000 * 60 * 60 * 24);
			return daysDiff > 0 && daysDiff <= 2;
		}).length;

		setcountData({
			newCount,
			pastDueCount,
			dueSoonCount,
		});
	}, [dateCountData]);

	const navigate = useNavigate();
	const navigateToTestScope = () => {
		//  navigation of 1st tile testscope
		navigate(
			urlWithTenant(
				`/${rrcpDashboardRoutes.testing}/${rrcpDashboardRoutes.testingHub}`,
			),
		);
	};
	const navigateToManagementReport = () => {
		//  navigation of 1st tile Report
	};
	const navigateToTestScriptHub = () => {
		navigate(
			urlWithTenant(
				`/${rrcpDashboardRoutes.testing}/${rrcpDashboardRoutes.testScriptHub}`,
			),
		);
	};
	const navigateToMethodology = () => {
		//  navigation of 1st tile Methodology
	};

	return (
		<Grid direction="column">
			<div className={styles['testing-monitoring-blue-background']}>
				<Grid
					container
					xs={12}
					className={styles['testing-monitoring-width-adjustment-expand']}
				>
					<Grid
						container
						direction="row"
						className={styles['testing-monitoring-count-stack']}
						data-testid="testing-monitoring-grid"
					>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Typography
								className={styles['testing-monitoring-test-plans-header']}
							>
								Test plans
							</Typography>
						</Grid>
						<Grid
							container
							className={styles['testing-monitoring-count-grid']}
							spacing={4}
							data-testid="testing-monitoring-count-grid"
						>
							{!isLoading ? (
								<Grid item xs={12} md={12} sm={12} lg={8}>
									<Stack
										direction="row"
										className={styles['testing-monitoring-count-box']}
									>
										<Stack
											direction="row"
											className={
												countData.newCount >= 1000
													? styles[
															'testing-monitoring-count-content-digits-divider'
													  ]
													: styles['testing-monitoring-count-content-divider']
											}
										>
											<Stack direction="column">
												<Typography
													className={styles['testing-monitoring-value-header']}
												>
													New
												</Typography>
												<Typography
													className={styles['testing-monitoring-value']}
												>
													{countData.newCount}
												</Typography>
											</Stack>
											<span
												className={styles['testing-monitoring-value-divider']}
											>
												<img src={DividingLine} alt="dividing line" />
											</span>
										</Stack>
										<Stack
											direction="row"
											className={
												countData.pastDueCount >= 1000
													? styles[
															'testing-monitoring-count-content-digits-divider'
													  ]
													: styles['testing-monitoring-count-content-divider']
											}
										>
											<Stack direction="column">
												<Typography
													className={styles['testing-monitoring-value-header']}
												>
													Past due
												</Typography>
												<Typography
													className={styles['testing-monitoring-value']}
												>
													{countData.pastDueCount}
												</Typography>
											</Stack>
											<span
												className={styles['testing-monitoring-value-divider']}
											>
												<img src={DividingLine} alt="dividing line" />
											</span>
										</Stack>
										<Stack
											direction="column"
											className={styles['testing-monitoring-count-content']}
										>
											<Typography
												className={styles['testing-monitoring-value-header']}
											>
												Due soon
											</Typography>
											<Typography
												className={styles['testing-monitoring-value']}
											>
												{countData.dueSoonCount}
											</Typography>
										</Stack>
									</Stack>
								</Grid>
							) : (
								<Paper
									className={styles['testing-monitoring-count-box']}
									data-testid="testing-monitoring-header-loader"
								>
									<CircularProgress
										className={styles['testing-monitoring-header-loader']}
									/>
								</Paper>
							)}
							<Grid item xs={12} sm={12} md={12} lg={4}>
								<Stack
									direction="row"
									justifyContent="space-between"
									className={styles['testing-monitoring-pannel-box']}
									onClick={navigateToTestScope}
									data-testid="test-scope-tile"
									sx={{ cursor: 'pointer' }}
								>
									<Typography
										className={styles['testing-monitoring-tiles']}
										sx={{ cursor: 'pointer' }}
									>
										Create,modify testing scope
									</Typography>
									<IconButton
										className={styles['testing-monitoring-icon']}
										disableRipple
									>
										<RightArrow
											className={styles['testing-monitoring-right-arrow']}
										/>
									</IconButton>
								</Stack>
							</Grid>
						</Grid>

						<Grid
							container
							data-testid="testing-monitoring-tiles-grid"
							spacing={4}
							className={styles['testing-monitoring-tiles-stack']}
						>
							<Grid item xs={12} sm={12} md={12} lg={4}>
								<Stack
									direction="row"
									justifyContent="space-between"
									className={styles['testing-monitoring-tile-box']}
									onClick={navigateToManagementReport}
									data-testid="test-report-tile"
								>
									<Typography
										className={styles['testing-monitoring-tiles-content']}
									>
										Change management report
									</Typography>
									<IconButton
										className={styles['testing-monitoring-tiles-icon']}
										disableRipple
									>
										<RightArrow
											className={styles['testing-monitoring-right-arrow']}
										/>{' '}
									</IconButton>
								</Stack>
							</Grid>
							<Grid item xs={12} sm={12} md={12} lg={4}>
								<Stack
									direction="row"
									justifyContent="space-between"
									className={styles['testing-monitoring-tile-box']}
									onClick={navigateToTestScriptHub}
									data-testid="test-hub-tile"
								>
									<Typography
										className={styles['testing-monitoring-tiles-content']}
									>
										Test script hub
									</Typography>
									<IconButton
										className={styles['testing-monitoring-tiles-icon']}
										disableRipple
									>
										<RightArrow
											className={styles['testing-monitoring-right-arrow']}
										/>
									</IconButton>
								</Stack>
							</Grid>
							<Grid item xs={12} sm={12} md={12} lg={4}>
								<Stack
									direction="row"
									justifyContent="space-between"
									className={styles['testing-monitoring-tile-box']}
									onClick={navigateToMethodology}
									data-testid="test-methodology-tile"
								>
									<Typography
										className={styles['testing-monitoring-tiles-content']}
									>
										T&M methodology
									</Typography>
									<IconButton
										className={styles['testing-monitoring-tiles-icon']}
										disableRipple
									>
										<RightArrow
											className={styles['testing-monitoring-right-arrow']}
										/>{' '}
									</IconButton>
								</Stack>
							</Grid>
						</Grid>
					</Grid>
					<div
						className={styles['testing-monitoring-divider-section']}
						data-testid="testing-monitoring-divider"
					>
						<hr className={styles['testing-monitoring-divider-line']} />
					</div>
				</Grid>
			</div>
		</Grid>
	);
};

export default TestMonitoringHeader;
